import { BaseClient } from '../client';
import { veiculoAcessorios } from '../offer/offer.mocks';
import { TVeiculoAcessorio } from '../offer/offer.types';

export const getVehicleAccessories = async () => {
	if (process.env.NODE_ENV === 'development') {
		return veiculoAcessorios;
	}

	try {
		const response = await BaseClient.get<TVeiculoAcessorio[]>(`/VeiculoAcessorios`).then(
			(response) => response.data
		);

		response.sort((a, b) => (a.veiculoAcessorio > b.veiculoAcessorio) ? 1 : -1);

		return response;
	} catch (error) {
		throw error;
	}
};
